module.exports = __webpack_public_path__ + "img/4.3.ec847c90.jpg";